import { Injectable } from '@angular/core';
import { BaseFormService } from 'ag-common-svc/lib/utils/base-form-service';
import {
  AirlinePreference,
  AirlinePreferenceKeys,
} from '@ag-common-lib/lib/models/utils/flight-preference.model';

@Injectable()
export class AirlinePreferenceFormService extends BaseFormService<Partial<AirlinePreference>> {
  constructor() {
    super();
  }

  getFormData = (airlinePreference: Partial<AirlinePreference>) => {
    if (airlinePreference) {
      airlinePreference[AirlinePreferenceKeys.isFirstChoiceAirline] = airlinePreference[AirlinePreferenceKeys.isFirstChoiceAirline] ?? false;
      airlinePreference[AirlinePreferenceKeys.isSecondChoiceAirline] = airlinePreference[AirlinePreferenceKeys.isSecondChoiceAirline] ?? false;
    }
    this.formData = new Proxy(airlinePreference, {
      set: (target, prop, value, receiver) => {
        const prevValue = target[prop];

        if (value !== prevValue) {
          this.formChangesDetector.handleChange(prop, value, prevValue);
          Reflect.set(target, prop, value, receiver);

          switch (prop) {
            default:
              break;
          }
        }
        return true;
      },
    });

    return this.formData;
  };
}
